/**
 * Adds a Referral Code link to the shopify-account profile menu when missing.
 */
(function () {
  const REFERRAL_PATH = '/pages/referrals';
  const REFERRAL_LABEL = 'REFERRAL CODE';
  const MARKER = 'data-herhe-referral-nav';

  /** @param {ParentNode} root */
  function hasReferralsLink(root) {
    return Array.from(root.querySelectorAll('a[href]')).some((anchor) => {
      const href = (anchor.getAttribute('href') || '').toLowerCase();
      return href.includes('/pages/referrals') || href.includes('/referrals');
    });
  }

  /** @param {ParentNode} root */
  function injectReferralLink(root) {
    if (root.querySelector(`[${MARKER}]`)) return;
    if (hasReferralsLink(root)) return;

    const menuLinks = Array.from(root.querySelectorAll('a[href]')).filter((anchor) => {
      const href = anchor.getAttribute('href') || '';
      return (
        href.includes('/account/') ||
        href.includes('/pages/') ||
        href.includes('shopify.com') ||
        href.startsWith('/')
      );
    });

    if (!menuLinks.length) return;

    const template = menuLinks[menuLinks.length - 1];
    const list = template.closest('ul, ol, menu, [role="menu"]');

    const anchor = document.createElement('a');
    anchor.href = REFERRAL_PATH;
    anchor.textContent = REFERRAL_LABEL;
    anchor.setAttribute(MARKER, 'true');

    if (window.location.pathname.includes('/pages/referrals')) {
      anchor.setAttribute('aria-current', 'page');
    }

    if (list instanceof Element) {
      const item = document.createElement('li');
      item.setAttribute(MARKER, 'true');
      item.appendChild(anchor);
      list.appendChild(item);
      return;
    }

    const wrapper = template.parentElement;
    if (!wrapper) return;

    wrapper.appendChild(anchor);
  }

  async function enhanceAccountMenu() {
    await customElements.whenDefined('shopify-account');
    const account = document.querySelector('shopify-account');
    const root = account?.shadowRoot;
    if (!root) return;

    const refresh = () => injectReferralLink(root);

    account.addEventListener('toggle', () => {
      window.requestAnimationFrame(refresh);
    }, true);
    account.addEventListener('pointerenter', refresh, true);
    new MutationObserver(refresh).observe(root, { childList: true, subtree: true });
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      enhanceAccountMenu().catch(() => {});
    });
  } else {
    enhanceAccountMenu().catch(() => {});
  }
})();
